import { render, staticRenderFns } from "./MotivoFotoRoute.vue?vue&type=template&id=60462b39"
import script from "./MotivoFotoRoute.vue?vue&type=script&lang=js"
export * from "./MotivoFotoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports